{
  "nav": {
    "overview": "Обзор",
    "campaigns": "Кампании",
    "billing": "Подписка",
    "notifications": "Уведомления",
    "users": "Пользователи",
    "adminBilling": "Биллинг",
    "broadcasts": "Рассылки",
    "globalConfig": "Фильтрация",
    "account": "Учётная запись",
    "actions": "Действия"
  },
  "actions": {
    "back": "Назад",
    "cancel": "Отмена",
    "close": "Закрыть",
    "confirm": "Подтвердить",
    "copy": "Скопировать",
    "create": "Создать",
    "delete": "Удалить",
    "discard": "Отменить",
    "edit": "Изменить",
    "language": "Сменить язык",
    "reload": "Перезагрузить",
    "retry": "Повторить",
    "save": "Сохранить",
    "search": "Поиск",
    "signIn": "Войти",
    "signOut": "Выйти",
    "themeDark": "Тёмная тема",
    "themeLight": "Светлая тема"
  },
  "locale": {
    "en": "English",
    "ru": "Русский"
  },
  "states": {
    "loading": "Загрузка…",
    "empty": "Пока пусто",
    "reconnecting": "Переподключение…",
    "newRows_one": "{{count}} новая строка",
    "newRows_few": "{{count}} новые строки",
    "newRows_many": "{{count}} новых строк",
    "unknown": "Неизвестно"
  },
  "errors": {
    "title": "Не удалось загрузить",
    "offlineTitle": "Нет соединения",
    "forbiddenTitle": "Нет доступа",
    "chunkTitle": "Вышла новая версия",
    "chunkMessage": "Перезагрузите страницу, чтобы продолжить.",
    "renderTitle": "Что-то сломалось на этом экране",
    "OFFLINE": "Сеть недоступна. Проверьте соединение и повторите.",
    "TIMEOUT": "Сервер слишком долго не отвечал.",
    "INVALID_RESPONSE": "Сервер вернул данные, которых экран не ожидает.",
    "SERVER_ERROR": "Сервер не смог обработать запрос.",
    "UNKNOWN": "Что-то пошло не так.",
    "BAD_REQUEST": "Запрос отклонён.",
    "PAYMENT_REQUIRED": "Нужна активная подписка.",
    "UNAUTHORIZED": "Сессия истекла. Войдите заново.",
    "FORBIDDEN": "Недостаточно прав для этого действия.",
    "NOT_FOUND": "Запись не найдена.",
    "CONFLICT": "Данные изменились. Обновите страницу.",
    "VALIDATION_ERROR": "Проверьте заполненные поля.",
    "TOO_MANY_REQUESTS": "Слишком много запросов. Подождите.",
    "INTERNAL_SERVER_ERROR": "Сервер не смог обработать запрос.",
    "SERVICE_UNAVAILABLE": "Сервис временно недоступен.",
    "GOAUTH_ALREADY_EXISTS": "Такой логин или email уже занят.",
    "GOAUTH_LAST_ADMIN": "Это последний активный администратор.",
    "GOAUTH_SELF_DEMOTE": "Нельзя снять права с самого себя.",
    "GOAUTH_REAUTH_REQUIRED": "Требуется подтверждение пароля.",
    "GOAUTH_PASSWORD_TOO_SHORT": "Пароль слишком короткий.",
    "GOAUTH_INVALID_IDENTIFIER": "Недопустимый логин или email.",
    "GOAUTH_NO_IDENTIFIER": "Нужен логин или email.",
    "GOAUTH_INVALID_CREDENTIALS": "Неверный пароль.",
    "GOAUTH_ACCOUNT_BLOCKED": "Учётная запись заблокирована.",
    "GOAUTH_ACCOUNT_DELETED": "Учётная запись удалена."
  },
  "auth": {
    "signInTitle": "Вход",
    "email": "Email",
    "password": "Пароль",
    "signInFailed": "Не удалось войти"
  },
  "validation": {
    "required": "Обязательное поле",
    "email": "Введите корректный email",
    "min": "Минимум {{count}} символов",
    "max": "Не более {{count}} символов"
  },
  "ui": {
    "allSections": "Все разделы",
    "breadcrumb": "Хлебные крошки",
    "clear": "Сбросить",
    "copied": "Скопировано",
    "loading": "Загрузка",
    "more": "Ещё",
    "nextPage": "Следующая страница",
    "noMatchDescription": "Изменить запрос или сбросить фильтры.",
    "notSelected": "Не выбрано",
    "nothingFound": "Ничего не найдено",
    "nothingSelected": "Ничего не выбрано",
    "opened": "Открыто",
    "pages": "Страницы",
    "prevPage": "Предыдущая страница",
    "rangeOf": "{{from}}–{{to}} из {{total}}",
    "remove": "Убрать",
    "resetFilters": "Сбросить фильтры",
    "rowActions": "Действия",
    "rowsPerPage": "Строк на странице",
    "sections": "Разделы",
    "selectAll": "Выбрать все",
    "selectRow": "Выбрать строку",
    "selectedCount": "Выбрано: {{count}}",
    "selectedOf": "{{count}} из {{total}}",
    "tableScroll": "Таблица, прокручивается по горизонтали",
    "thisSession": "Текущая сессия"
  },
  "source": {
    "google_search": "Google Поиск",
    "google_ads": "Google Ads",
    "meta_ads": "Meta Ads",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "reddit": "Reddit",
    "reddit_ads": "Reddit Ads",
    "x": "X",
    "x_ads": "X Ads",
    "bing_search": "Bing Поиск",
    "bing_ads": "Bing Ads",
    "yandex_search": "Яндекс Поиск",
    "yandex_ads": "Яндекс Директ",
    "telegram": "Telegram",
    "whatsapp": "WhatsApp",
    "direct": "Прямой заход",
    "organic": "Органика",
    "unknown": "Неизвестно"
  },
  "device": {
    "desktop": "Десктоп",
    "mobile": "Мобильный",
    "tablet": "Планшет"
  },
  "os": {
    "windows": "Windows",
    "macos": "macOS",
    "linux": "Linux",
    "android": "Android",
    "ios": "iOS"
  },
  "unsaved": {
    "title": "Изменения не сохранены",
    "description": "Если уйти сейчас, правки в этой форме будут потеряны.",
    "stay": "Остаться",
    "leave": "Уйти без сохранения"
  },
  "form": {
    "unsaved": "Есть несохранённые изменения"
  }
}
